export default __webpack_public_path__ + "static/AvenirNextCondensed-Bold-ab1eac855ce3664645acc7ba010be273.otf";